import { savePipelineJobId } from '../../../store/scan-to-print/scan-to-print.actions';
import { finalizeScanToPrintFulfillmentPlan } from '../../../store/scan-to-print/s2p-purchase-and-print.actions';
import Global from '../../../store/global-selectors';

export default (state, jobId) => {
  const jobData = Global.selectJobPipelineJobDataByJobId(state, { jobId });
  const { fulfillmentPlanId } = jobData;
  return [finalizeScanToPrintFulfillmentPlan(fulfillmentPlanId, jobId), savePipelineJobId(jobId)];
};
